export default __webpack_public_path__ + "static/media/BarbarianDays.82d087ea.jpg";